export default __webpack_public_path__ + "images/2F.18df6f2.png";